var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Dziękujemy za dokonanie wyboru. Udzielone zgody na przetwarzanie Państwa danych mogą być w każdej chwili zmienione. Aby dokonać zmiany należy wejść do zakładki "),_c('router-link',{attrs:{"to":{ name: 'user-consents' }}},[_vm._v(" Zgody ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }